import {
  CustomerPortalRequestState,
  CustomerPortalRequestType,
} from "../../api/models/unified";
import { TableQuery } from "../../common/models";
import { SelectItem } from "../../components/select/Select";

export const OrderRequestStateArray: CustomerPortalRequestState[] = [
  "Cancelled",
  "Resolved",
  "WaitingForCustomerUser",
  "Open",
];

// currently we do not support 'OrderRequestFromOwner'
export const OrderRequestTypeArray: CustomerPortalRequestType[] = [
  "Basic",
  "DataUpdate",
  "OrderRequest",
  "ServiceObjectUpdate",
  "OrderRequestFromOwner",
];

export interface CustomerPortalRequestTableQuery extends TableQuery {
  status?: string | null;
}

export interface CreateRequestPageState {
  formType?: CustomerPortalRequestType;
  serviceObject?: SelectItem;
  address?: SelectItem;
  allowedRequestTypes?: CustomerPortalRequestType[];
  customer?: SelectItem;
}
